import React, { useState } from 'react';
import { Card, Form, Button, Image, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import authemail from "assets/images/auth/email.png";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Axios } from 'api/axios'

const url = process.env.REACT_APP_BASE_URL;

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validation = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format")
        .required("Please Enter Your Email"),
    }),
    onSubmit: async (values) => {
      setIsSubmitting(true);
      try {
        const res: any = await Axios.post(`api/user/forgot-password-request/`, {
          email: values.email
        });

        if(res?.message==="Invalid Email ID"){
           toast.error(res?.message)
           return 
        }

        console.log(res, "forgot-password-response");

        // Check for successful response - API should confirm email exists
        const isSuccess = res?.data?.success || res?.data?.status === 'success' || 
                         (res?.message && !res?.error) || (res?.data?.message && !res?.data?.error);

        if (isSuccess) {
          toast.success(res?.data?.message || res?.message || "OTP sent successfully!");
          // Only navigate if email is valid and OTP was sent
          navigate('/verify-otp', { state: { email: values.email } });
        } else {
          // Email not found or other failure
          toast.error(res?.data?.message || res?.message || "Unable to send OTP. Please check your email.");
        }
      } catch (error: any) {
        console.error("Forgot password error:", error);
        // Handle errors - email not found, network issues, etc.
        const errorMessage = error?.response?.data?.message || 
                           error?.response?.data?.error ||
                           "Email not found. Please check and try again.";
        toast.error(errorMessage);
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  return (
    <div className="col-xxl-6 mx-auto">
      <Card className="card mb-0 border-0 shadow-none mb-0">
        <Card.Body className="p-sm-5 m-lg-4">
          <div className="text-center mt-2">
            <h5 className="fs-3xl">Forgot Password?</h5>
            <p className="text-muted mb-4">Reset password with ABGB Quotations Management</p>
            <div className="pb-4">
              <Image src={authemail} alt="Email icon" className="avatar-md" />
            </div>
          </div>
          
          <Alert className="border-0 alert-warning text-center mb-2 mx-2" role="alert">
            Enter your email and instructions will be sent to you!
          </Alert>
          
          <div className="p-2">
            <Form onSubmit={validation.handleSubmit}>
              <div className="mb-4">
                <Form.Label className="form-label">Email</Form.Label>
                <Form.Control
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="Enter Email"
                  name="email"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.email}
                  isInvalid={validation.touched.email && !!validation.errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {validation.errors.email}
                </Form.Control.Feedback>
              </div>

              <div className="text-center mt-4">
                <Button className="btn btn-primary w-100" type="submit" disabled={isSubmitting}>
                  {isSubmitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                      Sending...
                    </>
                  ) : (
                    "Send OTP"
                  )}
                </Button>
              </div>

              <div className="mt-4 text-center">
                <p className="mb-0">
                  Wait, I remember my password...{" "}
                  <Link to="/login" className="fw-semibold text-primary text-decoration-underline">
                    Click here
                  </Link>
                </p>
              </div>
            </Form>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ForgotPassword;